import { Profile, scaleImage } from '@news-mono/web-common'
import React from 'react'
import { createRenderTarget } from '../../../render-target'
import {
    StyledHeadshot,
    StyledHeadshotAmp,
    StyledHeadshotWrapper,
    StyledHeadshotWrapperLink,
} from '../Byline.styled'

export const ProfileImageResSize = 110
export const ProfileImageDisplaySize = 53

interface BylineProfileProps {
    profilePageLink?: boolean
    profile: Profile[]
}

export const BylineProfile: React.FC<BylineProfileProps> = ({
    profile,
    profilePageLink,
}) => {
    const profileImage = getProfileImage(profile)
    const profileLink = getProfileLink(profile)

    if (!profileImage) {
        return null
    }

    if (profileLink && profilePageLink) {
        return (
            <StyledHeadshotWrapperLink to={profileLink}>
                <Headshot
                    source={profileImage}
                    alt={
                        profile[0]
                            ? `Headshot of ${profile[0].name}`
                            : undefined
                    }
                />
            </StyledHeadshotWrapperLink>
        )
    }

    return (
        <StyledHeadshotWrapper>
            <Headshot
                source={profileImage}
                alt={profile[0] ? `Headshot of ${profile[0].name}` : undefined}
            />
        </StyledHeadshotWrapper>
    )
}

interface HeadshotProps {
    source: string
    alt: string | undefined
}

const Headshot = createRenderTarget<HeadshotProps>('Headshot', {
    web: ({ alt, source }) => <StyledHeadshot alt={alt} src={source} />,
    amp: ({ alt, source }) => (
        <StyledHeadshotAmp
            width={ProfileImageDisplaySize}
            height={ProfileImageDisplaySize}
            alt={alt}
            src={source}
        />
    ),
    rss: ({ alt, source }) => <img src={source} alt={alt} />,
    preview: ({ alt, source }) => <StyledHeadshot alt={alt} src={source} />,
    app: ({ alt, source }) => <StyledHeadshot alt={alt} src={source} />,
})
Headshot.displayName = 'Headshot'

function getProfileImage(profiles: Profile[]): string | undefined {
    for (const profile of profiles) {
        if (profile.thumbnailPhoto) {
            return scaleImage(profile.thumbnailPhoto, ProfileImageResSize)
        }
    }
    return undefined
}

function getProfileLink(profiles: Profile[]): string | undefined {
    for (const profile of profiles) {
        if (profile.thumbnailPhoto) {
            return `/profile/${profile.slug}`
        }
    }
    return undefined
}
